import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrNoteHeaderComponent } from './PatientChart/OR-Note/or-note-header/or-note-header.component';
import { VisitNoteHeaderComponent } from './PatientChart/visit-note-header/visit-note-header.component';
import { CheckinHeaderComponent } from './Calender/checkedin/checkin-header/checkin-header.component';
import { DemographicsHeaderComponent } from './PatientChart/Demographics/demographics-header/demographics-header.component';
import { MatControlsModule } from './MatControls.module';
import { OrVisitDetailsComponent } from './ChildControls/or-visit-details/or-visit-details.component';
import { CqmsComponent } from './ChildControls/cqms/cqms.component';
import { VisitDetailsComponent } from './ChildControls/visit-details/visit-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsentformsHeaderComponent } from './PatientChart/OR-Note/encounter-note/consentforms/consentforms-header/consentforms-header.component';
import { DeleteDocumentComponent } from './PatientChart/Document/delete-document/delete-document.component';
import { ShowSSRSReportComponent } from './ChildControls/show-ssrsreport/show-ssrsreport.component';
import { DocLibEMRConsentFormsComponent } from './doc-lib-emrconsent-forms/doc-lib-emrconsent-forms.component';
import { EditConsentFormsComponent } from './doc-lib-emrconsent-forms/edit-consent-forms/edit-consent-forms.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SignaturePadModule } from 'angular2-signaturepad';
import { OrderNoteHeaderComponent } from './order-note/order-note-header/order-note-header.component';
import { HomeordersDirective } from './home-orders/homeorders.directive';
import { HomeOrdersComponent } from './home-orders/home-orders.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule, MatSelectModule } from '@angular/material';
import { TemplateNotesComponent } from './Template/macros/template-notes/template-notes.component';
//import { FacilityProviderComponent } from './ChildControls/facility-provider/facility-provider.component';
import { EpcsAuditLogComponent } from './AdminModule/AdminConfiguration/audit-trail/epcs-audit-log/epcs-audit-log.component';
import { OrdersSelectDXComponent } from './ChildControls/orders-selectDx/orders-selectDx.component';
import { AddtoComboBoxComponent } from './ChildControls/addto-combo-box/addto-combo-box.component';
import { SMSComponent } from './sms/sms.component';
import { ViewDocumentComponent } from './PatientChart/Document/view-document/view-document.component';
import { IntstaffChatComponent } from './intstaff-chat/intstaff-chat.component';
import { TasksandmessagesTabComponent } from './message/tasksandmessages-tab/tasksandmessages-tab.component';
import { StatusColorsComponent } from './AdminModule/AdminConfiguration/status-colors/status-colors.component';
import { ClickOutsideDirective } from './shared/outsideclick.directive';
import { CqmsmodelwidgetComponent } from './cqmsmodelwidget/cqmsmodelwidget.component';
import { AlertsComponent } from './PatientChart/Demographics/patient-demographics/alerts/alerts.component';
import { DocumentComponent } from './PatientChart/Document/document.component';
import { ImportDocumentComponent } from './PatientChart/Document/import-document/import-document.component';
import { DocumentsHeaderComponent } from './ChildControls/documents-header/documents-header.component';
import { PatientConfirmDialogComponent } from './ChildControls/patient-confirm-dialog/patient-confirm-dialog.component';
import { PatientProceduresComponent } from './ChildControls/patient-procedures/patient-procedures.component';
import { ORDiagnosisComponent } from './ChildControls/ordiagnosis/ordiagnosis.component';
@NgModule({
    declarations: [
        OrNoteHeaderComponent,
        VisitNoteHeaderComponent,
        CheckinHeaderComponent,
        DemographicsHeaderComponent,
        OrVisitDetailsComponent,
        CqmsComponent,
        VisitDetailsComponent,
        ConsentformsHeaderComponent,
        DeleteDocumentComponent,
        ShowSSRSReportComponent,
        DocLibEMRConsentFormsComponent,
        EditConsentFormsComponent,
        OrderNoteHeaderComponent,
        //HomeordersDirective,
        //HomeOrdersComponent,
        TemplateNotesComponent,
        // FacilityProviderComponent,
        EpcsAuditLogComponent,
        //OrdersSelectDXComponent
        AddtoComboBoxComponent,
        SMSComponent,
        IntstaffChatComponent,
        TasksandmessagesTabComponent,
        StatusColorsComponent,
        ClickOutsideDirective,
        CqmsmodelwidgetComponent,
        AlertsComponent,
        DocumentComponent,
        ImportDocumentComponent,
        ViewDocumentComponent,
        DocumentsHeaderComponent,
        PatientConfirmDialogComponent,
        PatientProceduresComponent,
        ORDiagnosisComponent
    ]
    , entryComponents: [
        ShowSSRSReportComponent,
        DeleteDocumentComponent,
        TemplateNotesComponent,
        // FacilityProviderComponent,
        EpcsAuditLogComponent,
        AddtoComboBoxComponent,
        // OrdersSelectDXComponent
        VisitDetailsComponent,
        SMSComponent,
        TasksandmessagesTabComponent,
        PatientProceduresComponent,
        ORDiagnosisComponent
    ]
    , imports: [
        MatControlsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        NgxSpinnerModule,
        SignaturePadModule,
        // MatSlideToggleModule  ,
        // MatSelectModule  ,
        // MatListModule,
    ],
    exports: [
        OrNoteHeaderComponent,
        VisitNoteHeaderComponent,
        CheckinHeaderComponent,
        DemographicsHeaderComponent,
        MatControlsModule,
        OrVisitDetailsComponent,
        CqmsComponent,
        CqmsmodelwidgetComponent,
        VisitDetailsComponent,
        ConsentformsHeaderComponent,
        DeleteDocumentComponent,
        ShowSSRSReportComponent,
        DocLibEMRConsentFormsComponent,
        EditConsentFormsComponent,
        OrderNoteHeaderComponent,
        // HomeOrdersComponent,
        TemplateNotesComponent,
        EpcsAuditLogComponent,
        IntstaffChatComponent,
        TasksandmessagesTabComponent,
        StatusColorsComponent,
        ClickOutsideDirective,
        AlertsComponent,
        DocumentComponent,
        ViewDocumentComponent,
        ImportDocumentComponent,
        DocumentsHeaderComponent,
        PatientConfirmDialogComponent,
        PatientProceduresComponent
        // OrdersSelectDXComponent


    ]

})
export class SharedHeaderModule {
}